<script setup lang="ts">
const { isMobile } = useBreakpoint()
</script>

<template>
  <div v-if="isMobile" class="flex flex-row items-center">
    <div class="animate-wave h-[140px] w-[130px] flex-none"></div>
    <div class="flex w-full flex-col justify-center p-3">
      <div class="animate-wave mb-2 h-4 w-4/12"></div>
      <div class="animate-wave mb-4 h-3 w-10/12"></div>
      <div class="animate-wave h-3 w-10/12"></div>
    </div>
  </div>
  <div v-else>
    <div class="animate-wave h-[213px] w-[320px] rounded"></div>

    <div class="p-4">
      <div class="animate-wave mb-2 h-4 w-4/12"></div>
      <div class="animate-wave mb-4 h-3 w-10/12"></div>
      <div class="animate-wave h-3 w-10/12"></div>
    </div>
  </div>
</template>
